import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M10.2 15V9l4.8 3-4.8 3z" /><path fillRule="evenodd" clipRule="evenodd" d="M12 21.6a9.6 9.6 0 100-19.2 9.6 9.6 0 000 19.2zm0 1.2c5.965 0 10.8-4.835 10.8-10.8 0-5.965-4.835-10.8-10.8-10.8C6.035 1.2 1.2 6.035 1.2 12c0 5.965 4.835 10.8 10.8 10.8z" /></svg>;